import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import img from '../../../../assets/images/arrow-left.svg.js';
import img$1 from '../../../../assets/images/arrow-right.svg.js';
import css_248z from './carousel-navigation.scss.js';

function renderCustomSwiperNav(template, current, total) {
    return template
        .replace('#number1#', `<strong>${current.toString()}</strong>`)
        .replace('#number2#', `<strong>${total.toString()}</strong>`);
}
function onSlideChange(prevBtn, nextBtn) {
    prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.removeAttribute('disabled');
    nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.removeAttribute('disabled');
    if (prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.classList.contains('disabled'))
        prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.setAttribute('disabled', '');
    if (nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.classList.contains('disabled'))
        nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.setAttribute('disabled', '');
}
class CarouselNavigation extends s {
    constructor() {
        super(...arguments);
        this.darkBg = false;
        this.nextText = '';
        this.previousText = '';
    }
    render() {
        return x `<div class="swiper-nav ${this.rtl || isRTL() ? 'rtl' : ''} ${this.darkBg ? 'dark' : ''}"><icon-button class="swiper-button-prev" ?darkbgoutline="${this.darkBg}" ariaLabel="${this.previousText}" styleType="${this.darkBg
            ? ButtonStyleTypes.LIGHT
            : ButtonStyleTypes.OUTLINED_DARK}"><img slot="icon" src="${img}" alt="" aria-hidden="true"></icon-button><span class="swiper-counter"></span><icon-button class="swiper-button-next" ?darkbgoutline="${this.darkBg}" ariaLabel="${this.nextText}" styleType="${this.darkBg
            ? ButtonStyleTypes.LIGHT
            : ButtonStyleTypes.OUTLINED_DARK}"><img slot="icon" src="${img$1}" alt="" aria-hidden="true"></icon-button></div>`;
    }
}
CarouselNavigation.styles = css_248z;
__decorate([
    n({ type: Boolean })
], CarouselNavigation.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], CarouselNavigation.prototype, "darkBg", void 0);
__decorate([
    n({ type: String })
], CarouselNavigation.prototype, "nextText", void 0);
__decorate([
    n({ type: String })
], CarouselNavigation.prototype, "previousText", void 0);
customElements.define('carousel-navigation', CarouselNavigation);

export { CarouselNavigation, onSlideChange, renderCustomSwiperNav };
